<vex-loading-spinner></vex-loading-spinner>
<router-outlet></router-outlet>
<!-- <app-chat-bubble></app-chat-bubble> -->
